import { Crown, Sparkle } from "@phosphor-icons/react";

/**
 * FoundingProBadge — gold ribbon shown on the dashboard only for owners
 * who were already Pro BEFORE the Feb 2026 $15 price launch (paid
 * Founding subscribers on the $5/mo legacy price OR comp/manual-grant
 * free Pros). Reinforces "you were here first" loyalty and reduces
 * churn risk during pricing changes.
 *
 * Controlled purely by the backend `is_founding_pro` flag on /auth/me,
 * so this is render-only — no logic decisions here.
 *
 * Two size variants:
 *   - default ("md") — full ribbon for the dashboard hero
 *   - "sm"           — compact chip for public truck cards + profile hero
 */
export default function FoundingProBadge({ className = "", size = "md" }) {
  if (size === "sm") {
    return (
      <span
        className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-gradient-to-r from-amber-300 to-yellow-300 dark:from-amber-400/40 dark:to-yellow-400/40 border border-amber-400/60 text-[10px] uppercase tracking-wider font-bold text-amber-900 dark:text-amber-100 ${className}`}
        data-testid="founding-pro-badge"
        title="Founding Pro — supported TruckTrackr from day one."
      >
        <Crown weight="fill" className="h-2.5 w-2.5" />
        Founding
      </span>
    );
  }
  return (
    <div
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-gradient-to-r from-amber-200 via-amber-300 to-yellow-200 dark:from-amber-500/30 dark:via-amber-400/30 dark:to-yellow-500/30 border border-amber-400/60 shadow-sm ${className}`}
      data-testid="founding-pro-badge"
      title="You were Pro before Feb 2026 — thank you for being one of the originals."
    >
      <Crown weight="fill" className="h-3.5 w-3.5 text-amber-700 dark:text-amber-200" />
      <span className="text-[11px] font-bold uppercase tracking-wider text-amber-900 dark:text-amber-100">
        Founding Pro
      </span>
      <Sparkle weight="fill" className="h-3 w-3 text-amber-700 dark:text-amber-200" />
    </div>
  );
}
